import { jsx as o, Fragment as W, jsxs as O } from "react/jsx-runtime";
import { useRef as c, useState as y, useEffect as V, useCallback as u } from "react";
import q from "./CarouselUtils.class.js";
import { CarouselSlide as J } from "../CarouselSlide/CarouselSlide.js";
import { chunkArray as Q, classes as A } from "../../utils/helpers.js";
import { C as X } from "../../chevron-left-DmvQntvu.mjs";
import { C as Y } from "../../chevron-right-CaAz6ISN.mjs";
import '../../assets/Pagination.css';const Z = "_carousel_1acnl_1", ee = "_carousel__scroller_1acnl_11", a = {
  carousel: Z,
  carousel__scroller: ee,
  "carousel-controls": "_carousel-controls_1acnl_38",
  "carousel-controls__btn": "_carousel-controls__btn_1acnl_42",
  "carousel-controls__previous": "_carousel-controls__previous_1acnl_67",
  "carousel-controls__next": "_carousel-controls__next_1acnl_74",
  "carousel-nav": "_carousel-nav_1acnl_86",
  "carousel-nav__list": "_carousel-nav__list_1acnl_90",
  "carousel-nav__item": "_carousel-nav__item_1acnl_99"
}, re = window.matchMedia("(max-width: 600px)"), te = window.matchMedia("(max-width: 800px"), le = window.matchMedia("(max-width: 1024px"), ne = window.matchMedia("(max-width: 1280px");
function fe({
  id: z,
  slides: b,
  options: x = {
    paginationType: "dots",
    showControls: !0,
    controlArrowSize: 48,
    controlButtonsOffset: 12,
    showScrollbar: !1,
    startIndex: 0,
    variableHeight: !1,
    title: "",
    autoplay: !1,
    autoplayDelay: 3500,
    showPagination: !1,
    gutterSize: 25,
    slideAspectRatio: "4/2",
    slideGap: 1.5,
    cellsPerSlide: 1,
    cellAspectRatio: "4/2",
    cellsPosition: "center",
    wrapAround: !0
  }
}) {
  const _ = c(`carousel-${z}`), R = c(null), i = c(null), I = c(null), m = c(b), E = c(null), S = c(null), l = c(null), e = c(x), $ = c(x.showPagination), T = c("-50%"), [N, j] = y([]), [t, d] = y(null), [k, B] = y([]);
  V(() => {
    ((n = null) => {
      re.matches ? (d({
        ...e.current,
        showControls: !1,
        showPagination: !1,
        cellsPerSlide: 1,
        cellsPosition: e.current.wrapAround ? "center" : "flex-start",
        gutterSize: 10
      }), e.current = {
        ...e.current,
        showControls: !1,
        showPagination: !1,
        cellsPerSlide: 1,
        cellsPosition: e.current.wrapAround ? "center" : "flex-start",
        gutterSize: 10
      }, $.current = !1) : te.matches ? e.current.cellsPerSlide > 2 ? (d({
        ...e.current,
        cellsPerSlide: 2,
        showControls: !1,
        gutterSize: 10
      }), e.current = {
        ...e.current,
        cellsPerSlide: 2,
        showControls: !1,
        gutterSize: 10
      }) : (d({
        ...e.current,
        showControls: !1,
        gutterSize: 10
      }), e.current = {
        ...e.current,
        showControls: !1,
        gutterSize: 10
      }) : le.matches ? e.current.cellsPerSlide > 3 ? (d({
        ...e.current,
        cellsPerSlide: 3,
        showControls: !1,
        gutterSize: 10
      }), e.current = {
        ...e.current,
        cellsPerSlide: 3,
        showControls: !1,
        gutterSize: 10
      }) : (d({
        ...e.current,
        showControls: !1,
        gutterSize: 10
      }), e.current = {
        ...e.current,
        showControls: !1,
        gutterSize: 10
      }) : ne.matches && e.current.showPagination ? (d({
        ...e.current,
        showControls: !1
      }), e.current = {
        ...e.current,
        showControls: !1
      }) : d({
        ...e.current
      });
    })();
  }, []);
  const L = u((r, n) => {
    const f = Q(n, r);
    B([...f]);
    let h = [];
    for (let s = 0; s <= f.length - 1; s++) {
      h[s] = {}, h[s].ariaLabel = `${s + 1} of ${f.length}`, h[s].layout = f[s][0].layout, h[s].cells = [];
      for (let w = 0; w <= f[s].length - 1; w++)
        h[s].cells[w] = {
          props: f[s][w].props
        };
    }
    const C = [...h], P = [...h], K = C.slice(-1), F = C.slice(0);
    return P.push(F[0]), P.unshift(K[0]), e.current.wrapAround && r.length > n ? P : C;
  }, []), p = u(() => {
    e.current.autoplay && l.current.clearTimer();
  }, []), G = u((r) => {
    p();
    const n = r.key;
    n === "ArrowLeft" ? (r.preventDefault(), l.current.determineScrollAction(-1)) : n === "ArrowRight" && (r.preventDefault(), l.current.determineScrollAction(1));
  }, [p]), H = u((r) => {
    p(), i.current.addEventListener("scrollend", () => {
      l.current.handleScrollEnd();
    }, { once: !0 });
  }, [p]), g = u((r) => {
    p(), i.current.addEventListener("scrollend", () => {
      l.current.handleScrollEnd(), i.current.addEventListener("scroll", g, { once: !0 });
    }, { once: !0 });
  }, [p]), U = () => {
    l.current && e.current.autoplay && l.current.clearTimer();
  }, v = u(() => {
    //! make sure class is only instantiated once because of reacts
    //! "strict" mode double do hocus pocus
    l.current === null && (l.current = new q({
      carouselEl: R.current,
      scrollerEl: i.current,
      paginationEl: I.current,
      slides: m.current,
      navBtnEls: {
        next: E.current,
        previous: S.current
      },
      id: _.current,
      options: {
        autoplay: e.current.autoplay,
        wrapAround: e.current.wrapAround && m.current.length > e.current.cellsPerSlide,
        showPagination: e.current.showPagination,
        delay: e.current.autoplayDelay,
        slideGutterSize: e.current.gutterSize,
        slideAspectRatio: e.current.slideAspectRatio,
        showControls: e.current.showControls && m.current.length > e.current.cellsPerSlide,
        cellsPerSlide: e.current.cellsPerSlide
      }
    }));
  }, []), M = u(() => {
    i.current.addEventListener("scroll", g, { once: !0 });
  }, [g]), D = u(() => {
    if (j(L(m.current, e.current.cellsPerSlide)), m.current.length > e.current.cellsPerSlide) {
      let r = setInterval(() => {
        i.current !== null && (S.current !== null && e.current.showControls || !e.current.showControls) && (clearInterval(r), M(), v());
      }, 100);
    } else {
      let r = setInterval(() => {
        i.current !== null && (clearInterval(r), v());
      }, 100);
    }
  }, [L, M, v]);
  return V(() => {
    if (t !== null) {
      if (t.showControls) {
        let r = 0;
        t.showPagination && (r = r + 25), t.showScrollbar && (r = r + 6), T.current = `calc(-50% - ${r}px)`;
      }
      D();
    }
    return () => {
      U();
    };
  }, [D, t]), /* @__PURE__ */ o(W, { children: t !== null && /* @__PURE__ */ O(
    "div",
    {
      className: a.carousel,
      id: _.current,
      ref: R,
      tabIndex: -1,
      role: "region",
      "aria-roledescription": "carousel",
      "aria-label": t.title,
      onKeyDown: G,
      style: {
        "--_carousel-gutters": t.wrapAround ? `${t.gutterSize <= 25 ? t.gutterSize : 25}%` : `0 ${t.gutterSize <= 25 ? t.gutterSize : 25}%`,
        "--_slide-aspect-ratio": t.slideAspectRatio,
        "--_cell-aspect-ratio": t.cellAspectRatio,
        "--_slide-cell-size": `${100 / t.cellsPerSlide}%`,
        "--_cells-position": t.cellsPosition,
        "--_control-btns-offset-x": `${t.controlButtonsOffset}rem`,
        "--_slide-gap": `${t.slideGap}rem`,
        "--_controls-transform": T.current
      },
      children: [
        /* @__PURE__ */ o(
          "ol",
          {
            className: a.carousel__scroller,
            ref: i,
            role: "group",
            "aria-label": "Items Scroller",
            "aria-live": "Polite",
            tabIndex: 0,
            onMouseEnter: (r) => {
              e.current.autoplay && l.current !== null && l.current.clearTimer();
            },
            onMouseLeave: (r) => {
              e.current.autoplay && l.current !== null && l.current.startTimer();
            },
            onTouchStart: H,
            "data-scrollbar": t.showScrollbar,
            children: N.length > 0 && N.map((r, n) => /* @__PURE__ */ o(
              J,
              {
                slide: r,
                index: n,
                currentIndex: t.wrapAround ? 1 : 0,
                variableHeight: t.variableHeight
              },
              `carousel${z}-slide${n}`
            ))
          }
        ),
        t.showControls && b.length > e.current.cellsPerSlide && /* @__PURE__ */ O("div", { className: a["carousel-controls"], children: [
          /* @__PURE__ */ o(
            "button",
            {
              type: "button",
              ref: S,
              title: "Previous Item",
              className: A([a["carousel-controls__btn"], a["carousel-controls__previous"], "carousel-controls__previous"]),
              "aria-controls": _.current,
              "aria-label": "Previous Item",
              onClick: (r) => {
                l.current.determineScrollAction(-1);
              },
              onMouseEnter: (r) => {
                e.current.autoplay && l.current !== null && l.current.clearTimer();
              },
              onMouseLeave: (r) => {
                e.current.autoplay && l.current !== null && l.current.startTimer();
              },
              children: /* @__PURE__ */ o("i", { "aria-hidden": "true", children: /* @__PURE__ */ o(X, { width: t.controlArrowSize, height: t.controlArrowSize }) })
            }
          ),
          /* @__PURE__ */ o(
            "button",
            {
              type: "button",
              ref: E,
              title: "Next Item",
              className: A([a["carousel-controls__btn"], a["carousel-controls__next"], "carousel-controls__next"]),
              "aria-controls": _.current,
              "aria-label": "Next Item",
              onClick: (r) => {
                l.current.determineScrollAction(1);
              },
              onMouseEnter: (r) => {
                e.current.autoplay && l.current !== null && l.current.clearTimer();
              },
              onMouseLeave: (r) => {
                e.current.autoplay && l.current !== null && l.current.startTimer();
              },
              children: /* @__PURE__ */ o("i", { "aria-hidden": "true", children: /* @__PURE__ */ o(Y, { width: t.controlArrowSize, height: t.controlArrowSize }) })
            }
          )
        ] }),
        $.current && k.length > 1 && /* @__PURE__ */ o("div", { className: [a["carousel-nav"], "carousel-nav"].join(" "), children: /* @__PURE__ */ o("ol", { className: a["carousel-nav__list"], ref: I, children: k.map((r, n) => /* @__PURE__ */ o(
          "li",
          {
            className: A([a["carousel-nav__item"], "carousel-nav__item"]),
            "data-current": n === 0 ? "true" : "false",
            onClick: (f) => {
              l.current.navigateToIndex(n);
            },
            title: `Navigate to slide ${n + 1}`
          },
          `carousel${_}-nav-${n}`
        )) }) })
      ]
    }
  ) });
}
export {
  fe as Carousel,
  fe as default
};
